import { GdFreelancerProjectStatus } from '../../typings/graphql-grid';

export const REQUEST_COOP_BY_CUSTOMER_START = 'REQUEST_COOP_BY_CUSTOMER_START';
export type REQUEST_COOP_BY_CUSTOMER_START = typeof REQUEST_COOP_BY_CUSTOMER_START;

export const REQUEST_COOP_BY_CUSTOMER_SUCCESS = 'REQUEST_COOP_BY_CUSTOMER_SUCCESS';
export type REQUEST_COOP_BY_CUSTOMER_SUCCESS = typeof REQUEST_COOP_BY_CUSTOMER_SUCCESS;

export const REQUEST_COOP_BY_CUSTOMER_ERROR = 'REQUEST_COOP_BY_CUSTOMER_ERROR';
export type REQUEST_COOP_BY_CUSTOMER_ERROR = typeof REQUEST_COOP_BY_CUSTOMER_ERROR;

export const CHANGE_FREELANCER_ACCEPT_POPUP_PHONE = 'CHANGE_FREELANCER_ACCEPT_POPUP_PHONE';
export type CHANGE_FREELANCER_ACCEPT_POPUP_PHONE = typeof CHANGE_FREELANCER_ACCEPT_POPUP_PHONE;

export const FOCUS_FREELANCER_ACCEPT_POPUP_PHONE = 'FOCUS_FREELANCER_ACCEPT_POPUP_PHONE';
export type FOCUS_FREELANCER_ACCEPT_POPUP_PHONE = typeof FOCUS_FREELANCER_ACCEPT_POPUP_PHONE;

export interface ApproveCooperationByClientAction {
    type: REQUEST_COOP_BY_CUSTOMER_START;
    freelancerId: string;
    editPhone: string;
    originPhone: string;
}

export interface RequestCooperationByClientSuccessActionParams {
    freelancerId: string;
    clientId: string;
    projectId: string;
    projectCreatedTime: string;
    projectStartedTime?: string;
    projectFreelancerLogin: string;
    clientStatus: GdFreelancerProjectStatus;
}

export interface RequestCooperationByClientSuccessAction {
    type: REQUEST_COOP_BY_CUSTOMER_SUCCESS;
    data: RequestCooperationByClientSuccessActionParams;
}

export interface RequestCooperationByClientErrorAction {
    type: REQUEST_COOP_BY_CUSTOMER_ERROR;
}

export interface ChangeFreelancerAcceptPopupPhoneAction {
    type: CHANGE_FREELANCER_ACCEPT_POPUP_PHONE;
    value: string;
}

export interface FocusFreelancerAcceptPopupPhoneAction {
    type: FOCUS_FREELANCER_ACCEPT_POPUP_PHONE;
    value: boolean;
}

export function approveCooperationByClient(
    freelancerId: string,
    editPhone: string,
    originPhone: string
): ApproveCooperationByClientAction {
    return {
        type: REQUEST_COOP_BY_CUSTOMER_START,
        freelancerId,
        editPhone,
        originPhone
    };
}

export function requestCooperationByClientSuccess(
    data: RequestCooperationByClientSuccessActionParams
): RequestCooperationByClientSuccessAction {
    return {
        type: REQUEST_COOP_BY_CUSTOMER_SUCCESS,
        data
    };
}

export function requestCooperationByClientError(): RequestCooperationByClientErrorAction {
    return {
        type: REQUEST_COOP_BY_CUSTOMER_ERROR
    };
}

export function changeFreelancerAcceptPopupPhone(value: string): ChangeFreelancerAcceptPopupPhoneAction {
    return {
        type: CHANGE_FREELANCER_ACCEPT_POPUP_PHONE,
        value
    };
}

export function focusFreelancerAcceptPopupPhone(value: boolean): FocusFreelancerAcceptPopupPhoneAction {
    return {
        type: FOCUS_FREELANCER_ACCEPT_POPUP_PHONE,
        value
    };
}

export type FreelancerAcceptPopupAction =
    | ApproveCooperationByClientAction
    | RequestCooperationByClientSuccessAction
    | RequestCooperationByClientErrorAction
    | ChangeFreelancerAcceptPopupPhoneAction
    | FocusFreelancerAcceptPopupPhoneAction;
